import { render, staticRenderFns } from "./iinstall_dev_resource.vue?vue&type=template&id=b9a847b4&scoped=true&"
import script from "./iinstall_dev_resource.vue?vue&type=script&lang=ts&"
export * from "./iinstall_dev_resource.vue?vue&type=script&lang=ts&"
import style0 from "./iinstall_dev_resource.vue?vue&type=style&index=0&id=b9a847b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a847b4",
  null
  
)

export default component.exports